module.exports = __webpack_public_path__ + "img/tipocontacto03.acef962.svg";